import { Component, OnInit } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
@Component({
  selector: 'page-formulario31',
  templateUrl: './formulario31.component.html',
  styleUrls: ['./formulario31.component.css']
})
export class Formulario31Component implements OnInit {
  public nombreMuni = GLOBAL.nombreMuni;
  public region = GLOBAL.region;
  public tipo_permiso;
  public propiedad;
  public propietarios;
  public permiso_notariado;
  public arquitectos;
  public superficie_proyecto_modificado;
  public tipo_loteo;
  public cip;
  public caract_anteproy_loteo;
  public registro_bienes;
  public declaracion;
  public cond_anteproy;
  public porcentajes_anteproy;

 

//listas filtros

  public sup_total= 0;
  public largo_total ;

  public sup_porc= 0;
  public largo_porc = 0 ;

   pages = [1,2,3];

  constructor() {
 
    //CARACTERISTICAS ANTEPROYECTO LOTEO
    if(JSON.parse(localStorage.getItem("caract_anteproy_loteo"))){
      if (JSON.parse(localStorage.getItem("caract_anteproy_loteo")).length > 0){
        this.caract_anteproy_loteo = JSON.parse(localStorage.getItem("caract_anteproy_loteo"))
      }else{ 
       localStorage.setItem("caract_anteproy_loteo", JSON.stringify([]))
        this.caract_anteproy_loteo = [{sup_ant_loteo:'',num_anteproy_act:'',sup_anteproy_act:'',hoja_anexa_loteo:''}]
      }
    }

    //PORCENTAJES ANTEPROYECTO
    if(JSON.parse(localStorage.getItem("porcentajes_anteproy"))){
      if (JSON.parse(localStorage.getItem("porcentajes_anteproy")).length > 0){
        this.porcentajes_anteproy = JSON.parse(localStorage.getItem("porcentajes_anteproy"))
      }else{ 
       localStorage.setItem("porcentajes_anteproy", JSON.stringify([]))
        this.porcentajes_anteproy = [{sup_predios:'',porc_predios:'',cant_predios:'',sup_areas:'',porc_areas:'',cant_areas:'',sup_equip:'',porc_equip:'',cant_equip:'',sup_valid:'',porc_valid:'',cant_valid:'',sup_reserva:'',porc_reserva:'',cant_reserva:''}]
      }
    }

    console.log(this.caract_anteproy_loteo)
    if(this.caract_anteproy_loteo){
      for (let i = 0; i < this.caract_anteproy_loteo.length; i++) {
        
        this.sup_total = parseInt(this.caract_anteproy_loteo[i].sup_anteproy_act) + this.sup_total;
      }
      
      this.largo_total = this.caract_anteproy_loteo.length;

    }

    if(this.porcentajes_anteproy){
        
        this.sup_porc = parseInt(this.porcentajes_anteproy[0].sup_predios) + parseInt(this.porcentajes_anteproy[0].sup_areas) + parseInt(this.porcentajes_anteproy[0].sup_equip) + parseInt(this.porcentajes_anteproy[0].sup_valid) + parseInt(this.porcentajes_anteproy[0].sup_reserva);
        this.largo_porc = parseInt(this.porcentajes_anteproy[0].cant_predios) +  parseInt(this.porcentajes_anteproy[0].cant_areas) +  parseInt(this.porcentajes_anteproy[0].cant_equip) +  parseInt(this.porcentajes_anteproy[0].cant_valid) +  parseInt(this.porcentajes_anteproy[0].cant_reserva); 
        
    }
  }

   ngOnInit(){

   }

   ngAfterContentChecked(){
    this.ngAfterContentInit();
  }

   ngAfterContentInit() {
    //tipo permiso
    if(localStorage.getItem("tipo_permiso")){
      if (JSON.parse(localStorage.getItem("tipo_permiso")).length > 0){ 
        this.tipo_permiso = JSON.parse(localStorage.getItem("tipo_permiso"));
      }else{
        localStorage.setItem("tipo_permiso", JSON.stringify([]))
        this.tipo_permiso = [{obra:'',loteo_dfl:'',loteo_const:'', ampliacion:'',alteracion:'',reparacion:'',reconstruccion:'' }]
      }
      }

    //PROPIEDAD
    if(JSON.parse(localStorage.getItem("propiedad"))){
      if (JSON.parse(localStorage.getItem("propiedad")).length > 0){ 
        this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
      }else{
       localStorage.setItem("propiedad", JSON.stringify([]))
        this.propiedad = [{rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', loteo:'', manzana:'', plano:'', recordId:''}]
      }
    }
    

    //PROPIETARIOS
    if(JSON.parse(localStorage.getItem("propietarios"))){
      if (JSON.parse(localStorage.getItem("propietarios")).length > 0){
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
     }else{
        localStorage.setItem("propietarios", JSON.stringify([]))
        this.propietarios = [{rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''}]
     }
    }
    

     //PERMISO NOTARIADO
     if(JSON.parse(localStorage.getItem("permiso_notariado"))){
      if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0){
        this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
      }else{
       localStorage.setItem("permiso_notariado", JSON.stringify([]))
        this.permiso_notariado = [{acreditacion:'', fecha:null, escritura:null, notario:''}]
      }
     }
    

    //ARQUITECTOS
    if(JSON.parse(localStorage.getItem("arquitectos"))){
      if (JSON.parse(localStorage.getItem("arquitectos")).length > 0){
        this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"))
      }else{ 
       localStorage.setItem("arquitectos", JSON.stringify([]))
        this.arquitectos = [{rut: '', nombre:'', mail:'', apellido_mat:'', apellido_pat:'', direccion: '', direccion_complemento:'', direccion_num:'', comuna:'', fono:'', fax:'',  patente:'', recordId:''}]
      }
    }
    

    //TIPO LOTEO
    if(JSON.parse(localStorage.getItem("tipo_loteo"))){
      if (JSON.parse(localStorage.getItem("tipo_loteo")).length > 0){
        this.tipo_loteo = JSON.parse(localStorage.getItem("tipo_loteo"))
      }else{ 
       localStorage.setItem("tipo_loteo", JSON.stringify([]))
        this.tipo_loteo = [{loteo1:'',loteo2:'',loteo3:''}]
      }
    }
    

    //CIP
    if(JSON.parse(localStorage.getItem("cip"))){
      if (JSON.parse(localStorage.getItem("cip")).length > 0){
        this.cip = JSON.parse(localStorage.getItem("cip"))
      }else{ 
       localStorage.setItem("cip", JSON.stringify([]))
        this.cip = [{certcip:'',fecha_cip:''}]
      }
    }

    //CARACTERISTICAS ANTEPROYECTO LOTEO
    if(JSON.parse(localStorage.getItem("caract_anteproy_loteo"))){
      if (JSON.parse(localStorage.getItem("caract_anteproy_loteo")).length > 0){
        this.caract_anteproy_loteo = JSON.parse(localStorage.getItem("caract_anteproy_loteo"))
      }else{ 
       localStorage.setItem("caract_anteproy_loteo", JSON.stringify([]))
        this.caract_anteproy_loteo = [{sup_ant_loteo:'',num_anteproy_act:'',sup_anteproy_act:'',hoja_anexa_loteo:''}]
      }
    }
    

    //REGISTRO DE BIENES
    if(JSON.parse(localStorage.getItem("registro_bienes"))){
      if (JSON.parse(localStorage.getItem("registro_bienes")).length > 0){
        this.registro_bienes = JSON.parse(localStorage.getItem("registro_bienes"))
      }else{ 
       localStorage.setItem("registro_bienes", JSON.stringify([]))
        this.registro_bienes = [{inscrito:'',numero:'',anio:'',bienes:''}]
      }
    }
    
    //DECLARACION
    if(JSON.parse(localStorage.getItem("declaracion"))){
      if (JSON.parse(localStorage.getItem("declaracion")).length > 0){
        this.declaracion = JSON.parse(localStorage.getItem("declaracion"))
      }else{ 
       localStorage.setItem("declaracion", JSON.stringify([]))
        this.declaracion = [{plano:'',denominado:'',elaborado:'',profesion:''}]
      }
    }
    

    //CONDICIONANTES DEL ANTEPROYECTO
    if(JSON.parse(localStorage.getItem("cond_anteproy"))){
      if (JSON.parse(localStorage.getItem("cond_anteproy")).length > 0){
      this.cond_anteproy = JSON.parse(localStorage.getItem("cond_anteproy"))
      }else{ 
      localStorage.setItem("cond_anteproy", JSON.stringify([]))
        this.cond_anteproy = [{fusion:'',subdivision:'',estudio:'',edificacion:'',otros:''}]
      }
    }

    //PORCENTAJES ANTEPROYECTO
    if(JSON.parse(localStorage.getItem("porcentajes_anteproy"))){
      if (JSON.parse(localStorage.getItem("porcentajes_anteproy")).length > 0){
        this.porcentajes_anteproy = JSON.parse(localStorage.getItem("porcentajes_anteproy"))
      }else{ 
       localStorage.setItem("porcentajes_anteproy", JSON.stringify([]))
        this.porcentajes_anteproy = [{sup_predios:'',porc_predios:'',cant_predios:'',sup_areas:'',porc_areas:'',cant_areas:'',sup_equip:'',porc_equip:'',cant_equip:'',sup_valid:'',porc_valid:'',cant_valid:'',sup_reserva:'',porc_reserva:'',cant_reserva:''}]
      }
    }
    
    

  }

  captureScreen(){
    var pdf = new jspdf('p', 'mm', 'a4');

    html2canvas(document.getElementById(`page1`)).then(canvas => {
       const contentDataURL = canvas.toDataURL('image/png')
       pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });

    html2canvas(document.getElementById(`page2`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });
    html2canvas(document.getElementById(`page3`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)  
    });
    setTimeout(() =>{
      pdf.save(this.propietarios[0].rut+'.pdf')
     // pdf.save('prueba.pdf')
    },6000)
   }
}

